import styled from 'styled-components/macro';
import Button from '@tovia/man-ui/lib/components/Button/Button';

export const UpgradeButton = styled(Button)`
  background: #56c12b;
  border-radius: 3px;
  border: none;
  color: #ffffff;
  display: inline-block;
  font-size: 1rem;
  font-weight: 700;
  line-height: 32px;
  margin-top: 30px;
  opacity: 0.8;
  outline: none;
  padding: 0;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  transition: 0.3s opacity ease;
  width: 150px;

  :visited,
  :focus,
  :active,
  :hover {
    text-decoration: none;
  }

  :hover:not(.loading) {
    color: #ffffff;
    opacity: 1;
  }

  .spinner-wrap {
    height: 100%;
    width: 100%;

    :hover {
      color: transparent;
    }

    .spinner {
      width: 20px;
      height: 20px;

      path {
        fill: #888888;
      }
    }
  }
`;
